/**
 * 	IFS活动报名
 */
export default [
	{
	  path: '/activitySign',
	  component: () => import(/* webpackChunkName: "ActivitySign" */ '@/views/activitySign/Index.vue'),
	  meta: { requiresAuth: true, title: '活动报名', icon: '', role: true },
	  children:
		[
		  {
			path: '',
			component: () => import(/* webpackChunkName: "ActivitySign" */ '@/views/activitySign/List.vue'),
			meta: { title: '活动列表', role: true },
		  },
		  {
			path: 'info/:memberCardNo/:activityId',
			component: () => import(/* webpackChunkName: "ActivitySign" */ '@/views/activitySign/Info.vue'),
			meta: { title: '会员信息', role: true },
		  },
		],
	},
  ];